import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_COMPTET_SCHEMA_LITERAL = {
    title: 'Schéma Tiers',
    description: 'F_COMPTET',
    version: 0,
    keyCompression: false,
    //primaryKey: 'CT_NUM',
    primaryKey : { key : 'CT_NUM_PK', fields : ['USER_ID', 'CT_NUM'], separator : '_' },
    type: 'object',
    properties: {
        CT_NUM_PK: { type: 'string', maxLength: 60 },
        USER_ID: { type: 'string' },
        SITEGID: { type: 'string' },
        CT_TYPE: { type: 'number' },
        CT_PROSPECT: { type: 'number' },
        CT_NUM: { type: 'string', default: '', maxLength: 20 },
        CT_INTITULE: { type: 'string', default: '' },
        N_CATTARIF: { type: 'number' },
        N_CATTARIFLIB: { type: 'string', default: '' },
        N_CATCOMPTA: { type: 'number' },
        N_CATCOMPTALIB: { type: 'string', default: '' },
        N_DEVISE: { type: 'number' },
        N_DEVISELIB: { type: 'string', default: '' },
        N_DEVISE_COURS: { type: 'number' },
        N_DEVISE_FORMAT: { type: 'string', default: '' },
        CT_CONTACT : { type : 'string' },
        CT_COMMENTAIRE : { type : 'string' },
        CT_IDENTIFIANT: { type: 'string', default: '' },
        CT_APE: { type: 'string', default: '' },
        CT_SIRET: { type: 'string', default: '' },
        CT_TELEPHONE: { type: 'string', default: '' },
        CT_TELECOPIE : { type : 'string' },
        CT_EMAIL: { type: 'string', default: '' },
        CT_SITE : { type : 'string' },
        CT_LINKEDIN : { type : 'string' },
        CT_FACEBOOK : { type : 'string' },
        CT_ADRESSE: { type: 'string', default: '' },
        CT_COMPLEMENT: { type: 'string', default: '' },
        CT_VILLE: { type: 'string', default: '' },
        CT_PAYS: { type: 'string', default: '' },
        CT_CODEPOSTAL: { type: 'string', default: '' },
        CT_CODEREGION: { type: 'string', default: '' }, 
        CT_TAUX01 : { type: 'number' },
        CO_NO : { type: ['number', 'null'] },
        CO_NOLIB : { type: ['string', 'null'] },
        CONTACT_ITEMS_JSON : { type : 'string' },
        ADRESSE_ITEMS_JSON : { type : 'string' },
        EXTRA: { type: ['string', 'null'] }
    },
    required: ['CT_TYPE', 'CT_PROSPECT', 'CT_NUM', 'CT_INTITULE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(F_COMPTET_SCHEMA_LITERAL);
export type RxFCompteTDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_COMPTET_SCHEMA: RxJsonSchema<RxFCompteTDocumentType> = F_COMPTET_SCHEMA_LITERAL;
